import React from "react";
import styled from "styled-components";
import {device} from "../../assets/styles/media.js";
import spriteImage from '../../assets/images/sprite.png';
import { useNavigate} from "react-router-dom";

const Wrap = styled.ul`
    display: flex;
    margin: 60px auto 0;

    li:last-child {
        color: #ed8e0c;
    }

    ${device.tablet} {
        margin: 40px auto 0;
        zoom: 1.5;
    }

    ${device.mobile} {
        margin: 30px auto 0;
    }
`;

const Icon = styled.li`
    display: inline-block;
    width: 22px;
    height: 22px;
    cursor: pointer;

    &::after {
        margin: 0 auto;
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background-image: url(${spriteImage});
        background-size: 418px 402px;
        background-repeat: no-repeat;
        background-position: -378px -298px;
    }

    ${device.mobile} {
        transform: scale(0.9);
    }
`;
const Item = styled.li`
    height: 24px;
    padding-left: 9px;
    font-size: 16px;
    letter-spacing: -0.2px;
    font-weight: 400;
    cursor: pointer;

    &::before {
        content: "";
        display: inline-block;
        width: 4px;
        height: 4px;
        margin: 9px 9px 5px 0;
        border-radius: 100%;
        background: #dbdbdb;
    }

    ${device.mobile} {
        font-size: 14px;

        &::before {
            content: "";
            display: inline-block;
            width: 3px;
            height: 3px;
            margin: 10px 10px 5px 0;
            border-radius: 100%;
            background: #dbdbdb;
        }

        &:last-child {
            font-weight: 500;
        }
    }
`;


const BreadCrumb = ({title, subTitle, detail}) => {
    const navigate = useNavigate();
    return (
        <>
            <Wrap>
                <Icon onClick={() => navigate("/")}/>
                {title && <Item >{title}</Item>}
                {subTitle && <Item>{subTitle}</Item>}
                <Item>{detail}</Item>
            </Wrap>
        </>
    );
};

export default BreadCrumb;
